import React,{useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input, DatePicker} from 'antd';
import dayjs from 'dayjs'
import { useRenwuUpdateQuery, useRenwuUpdateSaveMutation } from '../store/BnsKeJiApi';
import MyEditor from '../cpn/MyEditor';
import GetUser from '../cpn/GetUser';
import {EditOutlined,} from '@ant-design/icons';
function TaskEdit(props) {    
    const {message} = App.useApp()
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        rw_id:props.rw_id
    }); 
    const {data,isSuccess} = useRenwuUpdateQuery({rw_id:props.rw_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    rw_name:data.Result.rw_name,
                    rw_dept_id:data.Result.rw_dept_id,
                    rw_content:data.Result.rw_content,
                    rw_js_uname:data.Result.rw_js_uname,
                    rw_end_date:dayjs(data.Result.rw_end_date),
                })
                setInfo(prevState=>({...prevState,
                    rw_content:data.Result.rw_content,
                    rw_dept_id:data.Result.rw_dept_id,
                    rw_e_id:data.Result.rw_e_id,
                    rw_end_date:data.Result.rw_end_date,
                    rw_fb_uid:data.Result.rw_fb_uid,
                    rw_fb_uname:data.Result.rw_fb_uname,
                    rw_js_uid:data.Result.rw_js_uid,
                    rw_js_uname:data.Result.rw_js_uname,
                    rw_name:data.Result.rw_name,
                    rw_state:data.Result.rw_state,
                    rw_uid:data.Result.rw_uid,
                    rw_uname:data.Result.rw_uname,               
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useRenwuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined />  修改</a>
            <Modal
                width={1200}                        
                open={open}
                title='修改产品'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.rw_id}`} 
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 21 }}
                    ref={editForm}
                >                    
                    <Form.Item
                        label='任务标题'
                        name='rw_name'
                    >
                        <Input
                            onChange={(e) => {setInfo(prev => ({...prev,rw_name:e.target.value}))}}
                        />
                    </Form.Item>
                    <Form.Item
                        label='任务正文'
                        name='rw_content'
                    >
                        <MyEditor 
                            height='400px'
                            width='800px'
                            onChange={(e) => {setInfo(prev => ({...prev,rw_content:e}))}}
                        />
                    </Form.Item>
                    <GetUser
                        label='执行人'
                        getUser={(e,f) => {
                            console.log(e,f);                        
                            setInfo(prev => ({...prev,rw_js_uid:e,rw_js_uname:f}))
                        }}
                        wrapperCol={{span:'4'}}
                        name='rw_js_uname'

                    />
                    <Form.Item
                        label='截止日期'
                        name='rw_end_date'
                    >
                        <DatePicker
                            onChange={(e) => {setInfo(prev => ({...prev,rw_end_date:dayjs(e).format('YYYY-MM-DD')}))}}
                        />
                    </Form.Item>                
                </Form>
            </Modal>
        </>
    )
}

export default TaskEdit